<div class="app-container"
     [class.hide-prices]="appState.hidePrices()"
     [class.is-impersonating]="isSupportSession()"
     [class.has-topbar]="showTopbar()">
  <app-impersonation-banner (exit)="onExitSupportSession()"></app-impersonation-banner>
  @if (showTopbar()) {
    <app-topbar
      [lastHome]="lastHome()"
      (navigateHome)="onNavigateHome($event)"
      (navigateOrders)="onNavigateOrders()"
      (navigateDrafts)="onNavigateDrafts()"
      (navigateCart)="onNavigateCart()"
      (navigateProfile)="onNavigateProfile()"
      (navigateProjects)="onNavigateProjects()"
      (navigateUploads)="onNavigateUploads()"
      (navigateGalleries)="onNavigateGalleries()"
      (navigateAlbumDesign)="onNavigateAlbumDesign()"
      (navigateDesigner)="onNavigateDesigner()"
      (navigateSupport)="onNavigateSupport()"
      (logout)="onLogout()">
    </app-topbar>
  }

  <main class="main-content" [class.with-topbar]="showTopbar()">
    <router-outlet></router-outlet>
  </main>

  <!-- Persiana toast host: fixed, slides down from behind the header. Rendered
       always (all routes) and kept OUTSIDE the scrolling main-content. -->
  <app-toast-host />
</div>

<!-- Global Editor Loading Overlay - shown while editor lazy-loads -->
@if (editorOpening()) {
  <div class="global-editor-loading-overlay">
    <div class="editor-loading-card">
      <img src="assets/logos/step2-loading-animation_3.svg" [alt]="'COMMON.LOADING' | translate" class="editor-loading-logo">
      <h2>{{ 'EDITOR.OPENING_EDITOR' | translate }}</h2>
      <p>{{ 'EDITOR.PLEASE_WAIT' | translate }}</p>
    </div>
  </div>
}

<!-- Global Capture Chain Loading Overlay - persists across route navigation -->
@if (captureChainLoading()) {
  <div class="global-capture-overlay">
    <div class="capture-overlay-card">
      <div class="capture-spinner-container">
        <div class="capture-spinner"></div>
        <svg class="capture-spinner-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
          <line x1="8" y1="21" x2="16" y2="21"/>
          <line x1="12" y1="17" x2="12" y2="21"/>
        </svg>
      </div>
      <div class="capture-overlay-text">
        <h2 class="capture-overlay-title">{{ 'PREVIEW.GENERATING_TITLE' | translate }}</h2>
        @if (captureChainLoading()?.progress?.total) {
          <p class="capture-overlay-subtitle">
            {{ 'PREVIEW.PHASE_CAPTURING' | translate: { current: captureChainLoading()?.progress?.current ?? 0, total: captureChainLoading()?.progress?.total ?? 0 } }}
          </p>
        } @else if (captureChainLoading()?.currentStep === 'uploading') {
          <p class="capture-overlay-subtitle">{{ 'PREVIEW.PHASE_UPLOADING' | translate }}</p>
        } @else {
          <p class="capture-overlay-subtitle">{{ captureChainLoading()?.message }}</p>
        }
      </div>
      @if (captureChainLoading()?.progress?.total) {
        <div class="capture-progress-bar">
          <div class="capture-progress-fill" [style.width.%]="((captureChainLoading()?.progress?.current ?? 0) / (captureChainLoading()?.progress?.total ?? 1)) * 100"></div>
        </div>
      } @else {
        <div class="capture-progress-dots">
          <div class="capture-dot"></div>
          <div class="capture-dot"></div>
          <div class="capture-dot"></div>
        </div>
      }
    </div>
  </div>
}
